import { jsxs, jsx } from 'react/jsx-runtime';
import { VisibilityOffAltIcon, VisibilityAltIcon } from '@flex-design-system/legacy-flex-icons';
import classNames from 'classnames';
import { forwardRef, useMemo } from 'react';
import '../../utils/styles/flex.mjs';
import Stack from '../../utils/styles/stack.mjs';
import { IconButton } from '../button/icon-button/IconButton.mjs';
import { BaseTextField } from './base/textField/BaseTextField.mjs';
import { useTogglePasswordField } from './hooks/useTogglePasswordField.mjs';
import { passwordIconRoot, passwordTypeToggleButton, passwordBaseTextField } from './passwordTextField.vanilla.mjs';

const PasswordTextField = forwardRef(
  ({
    className: classNameFromProps,
    rightSlot: rightSlotFromProps,
    size,
    ...props
  }, forwardedRef) => {
    const [inputType, togglePasswordVisible] = useTogglePasswordField({
      defaultVisible: false
    });
    const rightSlot = useMemo(() => {
      if (props.type !== "password") {
        return rightSlotFromProps;
      }
      const isPasswordVisible = inputType === "text";
      const PasswordIcon = isPasswordVisible ? VisibilityOffAltIcon : VisibilityAltIcon;
      return /* @__PURE__ */ jsxs(Stack.Horizontal, { children: [
        /* @__PURE__ */ jsx("div", { className: passwordIconRoot({ size }), children: /* @__PURE__ */ jsx(
          IconButton,
          {
            tabIndex: -1,
            className: passwordTypeToggleButton,
            icon: /* @__PURE__ */ jsx(
              PasswordIcon,
              {
                color: "grayLighter",
                role: "button",
                type: "fill",
                "aria-pressed": !isPasswordVisible ? "false" : "true",
                onClick: () => togglePasswordVisible()
              }
            ),
            variant: "ghost"
          }
        ) }),
        rightSlotFromProps
      ] });
    }, [
      inputType,
      props.type,
      rightSlotFromProps,
      size,
      togglePasswordVisible
    ]);
    return /* @__PURE__ */ jsx(
      BaseTextField,
      {
        ...props,
        className: classNames(passwordBaseTextField, classNameFromProps),
        size,
        type: inputType,
        ref: forwardedRef,
        rightSlot
      }
    );
  }
);

export { PasswordTextField as default };
//# sourceMappingURL=PasswordTextField.mjs.map
